export default __webpack_public_path__ + "static/media/soil-data.7562dc77.svg";